import { DialerSipOutlined } from '@mui/icons-material';
import { ListItemContainer, ListItemContent, ListItemIcon, ListItemProps } from './ListItem';

export const CallCredentialListItem: React.FC<ListItemProps> = (props) => {
  const { option, key, ...liProps } = props;

  return (
    <ListItemContainer key={key} {...liProps}>
      <ListItemIcon>
        <DialerSipOutlined sx={{ fontSize: '20px' }} />
      </ListItemIcon>
      <ListItemContent>
        <h1>{option?.label}</h1>
        {option?.metadata?.connection_name && <p id='small'>{option.metadata.connection_name}</p>}
      </ListItemContent>
    </ListItemContainer>
  );
};
